// What the housing provider outreach screens (the Email campaigns tab and the overview) read: every housing provider, Naima's
// mailbox from Resend, and the tracking worked out from the two.
import { listProviderProspects, loadAllRows } from './adminData.js';
import { buildOutreach } from './outreachTracking.js';
import { fetchMailbox } from './staffAdmin.js';

// The last outreach read while the dashboard is open (never saved anywhere), so going back to the Emails tab or the overview shows
// it at once while it is read again. Reading Naima's mailbox from Resend takes a few seconds.
let last = null;
let loadedAt = 0;
const listeners = new Set();
/** How often Naima's mailbox is read again while the dashboard is in front, so new replies appear by themselves. */
export const OUTREACH_REFRESH_EVERY = 10 * 60 * 1000;
/** The last outreach read in this browser tab, or null. */
export const lastOutreach = () => last;
/** When that was read (0 when it hasn't been). */
export const outreachLoadedAt = () => loadedAt;
/** Calls `listener` with each new read. Answers how to stop. */
export function onOutreach(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
/** Forgets it, as a fresh page would. */
export function forgetOutreach() { last = null; loadedAt = 0; }

/**
 * `{ rows, unmatched, summary, complete }` (see `buildOutreach`); `complete` is false when Naima has more emails than were read.
 * `isCurrent()` is asked while the provider list is read: once it says no the rest is skipped and the result is null.
 */
export async function loadOutreach(client, { isCurrent = () => true } = {}) {
  const [providers, mailbox] = await Promise.all([
    loadAllRows((page) => listProviderProspects(client, page), { isCurrent }),
    fetchMailbox(client, 'outreach'),
  ]);
  if (!providers) return null;
  last = { ...buildOutreach({ providers: providers.rows, sent: mailbox.sent || [], received: mailbox.received || [] }), complete: mailbox.complete !== false };
  loadedAt = Date.now();
  listeners.forEach((listener) => listener(last));
  return last;
}
